import React from "react";
function trialItem(userTrial) {
    return (React.createElement("li", null,
        userTrial.title,
        " - ",
        userTrial.value));
}
export function trialList(userTrials) {
    return React.createElement("ul", null, userTrials.map(trialItem));
}
